/**
 * Configuration options for document analysis
 */
export interface AnalysisConfig {
  autoClassificationEnabled: boolean;
  pollingInterval: number;
  maxPollingTime: number;
  sequentialLoading: boolean;
}

/**
 * SERVICE-LEVEL STATUS
 * Represents the overall state of the DocumentAnalysisService
 * Used for UI indicators and controlling the service workflow
 */
export type AnalysisStatus = 'idle' | 'loading' | 'analyzing' | 'polling' | 'complete' | 'error';

/**
 * DOCUMENT-LEVEL STATUS
 * Represents the extraction status of a single document as reported by the backend API
 * These values come directly from the document analysis API responses
 */
export type ExtractionStatus =
  | 'pending'
  | 'text_extracted'
  | 'ocr_complete'
  | 'classified'
  | 'generating extraction prompt'
  | 'extract prompt successful'
  | 'starting classification'
  | 'extracted'
  | 'failed'
  | 'extraction failed'
  | 'extraction prompt failed';
/**
 * State of an individual document in the analysis process
 * Combines document ID with its current extraction status and data
 */
export interface DocumentExtractionState {
  documentId: string;
  extractionStatus: ExtractionStatus;
  extractionRecordId?: string;
  extractionData?: any;
  status?: any; // The old status format for backward compatibility
  error?: string;
}

/**
 * Default configuration values
 */
export const DEFAULT_ANALYSIS_CONFIG: AnalysisConfig = {
  autoClassificationEnabled: false,
  pollingInterval: 10000, // 10 seconds
  maxPollingTime: 60000, // 1 minute
  sequentialLoading: false
};
